/* ver 1.3 */

import * as THREE from "three";

export const Create = {
  cone: (unify, name) => {
    var coneGeo = new THREE.ConeGeometry();
    var coneMat = new THREE.MeshBasicMaterial({ color: 0xc0c0c0 });
    var shape = new THREE.Mesh(coneGeo, coneMat);

    if (name == null) name = "cone";
    shape.name = name;
    if (unify != null && typeof unify == "object") unify.scene.add(shape);

    return shape;
  },

  sphere: (unify, name) => {
    var geometry = new THREE.SphereGeometry(0.5, 24, 24);
    var material = new THREE.MeshBasicMaterial({ color: 0xc0c0c0 });
    var shape = new THREE.Mesh(geometry, material);

    if (name == null) name = "sphere";
    shape.name = name;
    if (unify != null) unify.scene.add(shape);

    return shape;
  },

  cube: (unify, name) => {
    var geometry = new THREE.BoxGeometry();
    var material = new THREE.MeshBasicMaterial({ color: 0xc0c0c0 });
    var shape = new THREE.Mesh(geometry, material);

    if (name == null) name = "cube";
    shape.name = name;
    if (unify != null) unify.scene.add(shape);

    return shape;
  },

  circle: (unify, name) => {
    var geometry = new THREE.CircleGeometry(100, 100);
    var material = new THREE.MeshBasicMaterial({ color: 0xc0c0c0 });
    var shape = new THREE.Mesh(geometry, material);

    if (name == null) name = "circle";
    shape.name = name;
    if (unify != null) unify.scene.add(shape);

    return shape;
  },

  cylinder: (unify, name) => {
    var geometry = new THREE.CylinderGeometry();
    var material = new THREE.MeshBasicMaterial({ color: 0xc0c0c0 });
    var shape = new THREE.Mesh(geometry, material);

    if (name == null) name = "cylinder";
    shape.name = name;
    if (unify != null) unify.scene.add(shape);

    return shape;
  },

  torus: (unify, name) => {
    var geometry = new THREE.TorusGeometry();
    var material = new THREE.MeshBasicMaterial({ color: 0xc0c0c0 });
    var shape = new THREE.Mesh(geometry, material);

    if (name == null) name = "torus";
    shape.name = name;
    if (unify != null) unify.scene.add(shape);

    return shape;
  },

  tetrahedron: (unify, name) => {
    var geometry = new THREE.TetrahedronGeometry();
    var material = new THREE.MeshBasicMaterial({ color: 0xc0c0c0 });
    var shape = new THREE.Mesh(geometry, material);

    if (name == null) name = "tetrahedron";
    shape.name = name;
    if (unify != null) unify.scene.add(shape);

    return shape;
  },

  octahedron: (unify, name) => {
    var geometry = new THREE.OctahedronGeometry();
    var material = new THREE.MeshBasicMaterial({ color: 0xc0c0c0 });
    var shape = new THREE.Mesh(geometry, material);

    if (name == null) name = "octahedron";
    shape.name = name;
    if (unify != null) unify.scene.add(shape);

    return shape;
  },

  icosahedron: (unify, name) => {
    var geometry = new THREE.IcosahedronGeometry();
    var material = new THREE.MeshBasicMaterial({ color: 0xc0c0c0 });
    var shape = new THREE.Mesh(geometry, material);

    if (name == null) name = "icosahedron";
    shape.name = name;
    if (unify != null) unify.scene.add(shape);

    return shape;
  },

  dodecahedron: (unify, name) => {
    var geometry = new THREE.DodecahedronGeometry();
    var material = new THREE.MeshBasicMaterial({ color: 0xc0c0c0 });
    var shape = new THREE.Mesh(geometry, material);

    if (name == null) name = "dodecahedron";
    shape.name = name;
    if (unify != null) unify.scene.add(shape);

    return shape;
  },

  plane: (unify, name) => {
    var geometry = new THREE.PlaneGeometry();
    var material = new THREE.MeshBasicMaterial({
      color: 0xc0c0c0,
      side: THREE.DoubleSide
    });
    var shape = new THREE.Mesh(geometry, material);

    if (name == null) name = "plane";
    shape.name = name;
    if (unify != null) unify.scene.add(shape);

    return shape;
  }
};
